<template>
  <el-drawer
    :title="`用户列表，所属部门：${dept.deptName}`"
    :visible.sync="isShow"
    direction="rtl"
    size="60%"
    :destroy-on-close="true"
    :show-close="true"
    :wrapperClosable="true"
    @close="closeDrawer"
  >
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-lx-add"
            @click="showChooseUserDialog"
          >添加用户</el-button>
        </div>

        <div class="icon-group">
          <span
            class="icon-box"
            @click="refreshAllotUserList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <el-table
        v-loading="loading"
        element-loading-background="rgba(245, 245, 245, 0.3)"
        size="small"
        :data="allotUserList"
        row-key="id"
        height="400px"
        @selection-change="handleAllotSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        > </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="头像"
          width="100px"
        >
          <template slot-scope="scop">
            <div class="flex justify-center">
              <img
                :src="scop.row.userHeader"
                alt=""
                class="w-14 h-14 rounded-full"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="userName"
          label="登录名"
          width="100px"
        > </el-table-column>
        <el-table-column
          align="center"
          prop="userRealname"
          label="姓名"
          width="100px"
        > </el-table-column>
        <el-table-column
          align="center"
          label="公司"
          width="170"
        >
          <template slot-scope="scop">
            <el-tag
              size="normal"
              effect="light"
              v-if="scop.row.company"
            >{{ scop.row.company.deptName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="部门"
          width="170"
        >
          <template slot-scope="scop">
            <el-tag
              size="normal"
              effect="light"
              v-if="scop.row.mppDept"
            >{{ scop.row.mppDept.deptName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="状态"
          width="80"
        >
          <template slot-scope="scop">
            <el-tag
              type="success"
              effect="light"
              v-if="scop.row.status == 1"
            >正常</el-tag>
            <el-tag
              type="danger"
              effect="light"
              v-if="scop.row.status == 0"
            >禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          width="120"
        >
          <template slot-scope="scop">
            <div class="operation">
              <span
                class="operation-label"
                @click="deleteUserFromDept(scop.row.id)"
              >移除</span>
            </div>
          </template>

        </el-table-column>

      </el-table>
      <div class="pagination-box">
        <el-pagination
          
          @size-change="allotSizeChange"
          @current-change="allotCurrentChange"
          :current-page.sync="allotCurrentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="allotPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allotTotalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
      <!-- 新增/查看/修改用户信息 -->
      <el-dialog
        title="用户选择"
        :modal="false"
        :visible.sync="showDialog"
        width="80%"
        
        @close="closeDialog"
      >
        <div class="el-dialog-div" >
          <div class="flex h-full" >
            <div class="organization" >
              <div class="search">
                <!-- <el-input
                  v-model="organizationKeyword"
                  placeholder="组织机构 请输入关键字过滤"
                  size="small"
                  clearable
                  style="width:180px"
                ></el-input> -->
              </div>

              <el-tree
                default-expand-all
                :data="departmentList"
                :props="treeProps"
              >
                <div
                  class="custom-tree-node flex items-center"
                  slot-scope="{ node, data }"
                >
                  <Icon v-if="data.parentId == '0'">
                    <Organization24Filled />
                  </Icon>
                  <Icon v-if="data.parentId == '1'">
                    <PeopleCommunity24Filled />
                  </Icon>
                  <Icon v-if="data.parentId == '2'">
                    <Person24Filled />
                  </Icon>
                  <span class="ml-1">{{ node.label }}</span>
                </div>
              </el-tree>
            </div>
            <div
              style="display: flex; flex-direction: column; flex: 1"
              class="overflow-auto mx-5"
            >
              <div>
                <el-form
                  :model="queryForm"
                  ref="queryForm"
                  label-width="120px"
                  :inline="true"
                  size="small"
                
                  @submit.native.prevent
                >
                  <el-form-item label="">
                    <el-input
                     style="width:200px"
                      v-model="queryForm.userName"
                      placeholder="登录名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="">
                    <el-input
                    style="width:200px"
                      v-model="queryForm.userRealname"
                      placeholder="姓名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="small"
                      type="primary"
                      icon="el-icon-search"
                      @click="getUserList(queryForm)"
                    >查询</el-button>
                    <el-button
                      size="small"
                      icon="el-icon-refresh"
                      @click="resetUserList"
                    >重置</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <el-table
                v-loading="loading"
                element-loading-background="rgba(245, 245, 245, 0.3)"
                size="small"
                :data="userList"
                row-key="id"
                height="100%"
                ref="userTable"
                @selection-change="handleSelectionChange"
              >

                <el-table-column
                  align="center"
                  type="selection"
                  width="55"
                > </el-table-column>
                <el-table-column
                  align="center"
                  prop="userHeader"
                  label="头像"
                  width="100"
                >
                  <template slot-scope="scop">
                    <div class="flex justify-center">
                      <img
                        :src="scop.row.userHeader"
                        alt=""
                        class="w-14 h-14 rounded-full"
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="userName"
                  label="登录名"
                  width="100"
                > </el-table-column>
                <el-table-column
                  align="center"
                  prop="userRealname"
                  label="姓名"
                  width="100"
                > </el-table-column>
                <el-table-column
                  align="center"
                  label="公司"
                  width="170"
                >
                  <template slot-scope="scop">
                    <el-tag
                      size="normal"
                      effect="light"
                      v-if="scop.row.company"
                    >{{ scop.row.company.deptName }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="部门"
                  width="170"
                >
                  <template slot-scope="scop">
                    <el-tag
                      size="normal"
                      effect="light"
                      v-if="scop.row.mppDept"
                    >{{ scop.row.mppDept.deptName }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="状态"
                  width="80"
                >
                  <template slot-scope="scop">
                    <el-tag
                      type="success"
                      effect="light"
                      v-if="scop.row.status == 1"
                    >正常</el-tag>
                    <el-tag
                      type="danger"
                      effect="light"
                      v-if="scop.row.status == 0"
                    >禁用</el-tag>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination-box">
                <el-pagination
                  @size-change="sizeChange"
                  @current-change="currentChange"
                  :current-page.sync="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalNum"
                  background
                  :pager-count="7"
                >
                </el-pagination>
              </div>
            </div>
            <div class="w-48">
              <span
                v-for="item in multipleSelection"
                :key="item.id"
                class="inline-block mr-2 mb-2"
              >
                <el-tag
                  size="normal"
                  effect="light"
                  closable
                  @close="removeChooseUser(item)"
                >{{ item.userName }}</el-tag>
              </span>
            </div>
          </div>
          <div
            slot="footer"
            class="flex justify-end"
          >
            <el-button @click="closeDialog">关闭</el-button>
            <el-button
              type="primary"
              @click="submitChooseUser"
            >确定</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </el-drawer>
</template>

<script>
import {  getUserListByDeptId, deleteUserFromDept,addUserListByDeptId } from '@/api/dept.js';
import { GridDots, Refresh } from '@v2icons/tabler';
import { getDepartmentList } from '@/api/dept.js';
import { getUserList } from '@/api/user.js';

import { PeopleCommunity24Filled, Person24Filled, Organization24Filled } from '@v2icons/fluent';

export default {
    name: 'AllotUser',
    components: {
        Refresh,
        GridDots,
        Person24Filled,
        Organization24Filled,
        PeopleCommunity24Filled
    },
    props: {
        dept: Object,
        default() {
            return {};
        }
    },
    data() {
        return {
            isShow: false,
            currentPage: 1,
            pageSize: 10,
            totalNum: 0,
            userList: [],
            allotCurrentPage: 1,
            allotPageSize: 10,
            allotTotalNum: 0,
            allotUserList: [],
            showDialog: false,
            multipleSelection: [],
            allotMultipleSelection: [],
            loading: false,
            organizationKeyword: '',
            queryForm: {
                userName: '',
                userRealname: ''
            },
            departmentList: [],
            treeProps: {
                children: 'children',
                label: 'deptName'
            }
        };
    },
    methods: {
        init() {
            this.isShow = true;
            console.log(this.dept);
             this.getUserListByDeptId();
        },
        refreshAllotUserList() {
            this.allotCurrentPage = 1;
            this.allotPageSize = 10;
            this.allotUserList = [];
            this.getUserListByDeptId();
        },
        resetUserList() {
            this.queryForm = {
                userRealname: '',
                userName: ''
            };
            this.currentPage = 1;
            this.pageSize = 10;
            this.userList = [];
            this.getUserList();
        },
        showChooseUserDialog() {
            this.showDialog = true;
            this.getDepartmentList();
            this.getUserList();
        },
        getUserListByDeptId() {
            this.loading = true;
            console.log("this.dept.id"+this.dept.id);
            getUserListByDeptId({ deptId: this.dept.id, pageNum: this.allotCurrentPage, pageSize: this.allotPageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.allotUserList = res.page.list;
                    this.allotTotalNum = res.page.total;
                }
            });
        },
        closeDrawer() {
            this.isShow = false;
            this.allotUserList = [];
            this.allotTotalNum = 0;
        },
        deleteUserFromDept(id) {
            console.log(id);
            console.log(this.dept.id);
            deleteUserFromDept({ userId: id, deptId: this.dept.id }).then((res) => {
                if (res.success && res.code == 200) {
                   this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                            });
                    this.getUserListByDeptId();
                }
            });
        },
        getUserList(query = {}) {
            getUserList({ ...query, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                if (res.success) {
                    this.userList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getDepartmentList() {
            getDepartmentList().then((res) => {
                if (res.success) {
                    this.departmentList = res.treeData;
                }
            });
        },
        closeDialog() {
            this.showDialog = false;
        },
        submitChooseUser() {
            this.showDialog = false;

            for(var i = 0 ; i< this.multipleSelection.length;i++){
            console.log("this.multipleSelection"+this.multipleSelection[i].id);
            }
            const ids = this.multipleSelection.map((user) => user.id).join(',');
            console.log("this.ids"+ids)
            addUserListByDeptId({ deptId: this.dept.id, ids }).then((res) => {
                if (res.success && res.code == 200 ) {
                    this.getUserListByDeptId();
                }
            });
        },
        removeChooseUser(user) {
            console.log({ user });
            this.multipleSelection = this.multipleSelection.filter((item) => item.id != user.id);

            this.$refs.userTable.toggleRowSelection(user, false);
        },
        allotSizeChange(pageSize) {
            this.allotPageSize = pageSize;
            this.getUserListByDeptId();
        },
        sizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getUserList();
        },
        allotCurrentChange(currentPage) {
            this.allotCurrentPage = currentPage;
            this.getUserListByDeptId();
        },
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.getUserList();
        },
        handleAllotSelectionChange(value) {
            console.log(value);
            this.allotMultipleSelection = value;
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    height: 60%;
}
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
::v-deep .el-dialog__body {
    height: 80%;
}

::v-deep .el-dialog__footer {
    height: 15%;
}
::v-deep .el-dialog-div {
    height: 100%;
}
.page-content {
    height: 500px;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;

    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
        cursor: pointer;
    }
}
</style>
